export const localizeValidation = {
    props: {
        i18n: Object,
    },
    data() {
        return {};
    },
    methods: {
        localizeValidation() {
            this.$validator.localize("ru", {
                messages: {
                    required: () => this.$t("login.required"),
                    min: () => this.$t("register.leastCharacters"),
                    date_format: () => this.$t("register.correctDateFormat"),
                    email: () => this.$t("register.invalidEmailAddress"),
                    confirmed: () => this.$t("register.passwordsMatch"),
                    size: (field, size) =>
                        this.$t("register.imageSizeMax") +
                        +this.$t("mixins.mb"),
                    ext: (field, ext) => {
                        let str = this.$t("register.possibleLoadOnly");
                        for (let i = 0; i < ext.length; i++) {
                            str += ext[i];
                            if (i < ext.length - 2) {
                                str += ", ";
                            } else if (i < ext.length - 1) {
                                str += this.$t("register.and");
                            } else {
                                str += ".";
                            }
                        }
                        return str;
                    },
                    regex: () => this.$t("feedback.phoneFormat"),
                    min_value: () => this.$t("register.specifyAmount"),
                    max_value: () =>
                        this.$t("register.specifyAmountNotExceeding"),
                    credit_card: () => this.$t("register.enterCardNumber"),
                },
            });
        },
    },
};
